import React from 'react';
import { Icon } from './Icon.js';
export const IconStackFilled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("rect", { x: "1", y: "5", width: "14", height: "10", rx: "1.5", ry: "1.5", transform: "translate(-2 18) rotate(-90)", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", fill: "currentColor" }),
        React.createElement("line", { x1: "17", y1: "15", x2: "17", y2: "5", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" })));
};
//# sourceMappingURL=IconStackFilled.js.map